import ApiService from '@/services/api.service'

export default {
    namespaced: true,
	state: {
		languages: [],
		isLoaded: false,
		//missingBuffer: [], // a buffer for when a call to the missing translations api cannot be done (not loggedin, messages not loaded yet) 
	},
	getters: {
		getList: state => state.languages,
		isLoaded: state => state.isLoaded
	},
	mutations: {
        setLanguages(state, languages) {
            state.languages = languages
		},
		setIsLoaded(state) {
			state.isLoaded = true
		},
		//setMissingTranslation(state, locale, key) {
		//	state.missingBuffer.push({
		//		'locale' : locale,
		//		'key'	 : key
		//	}) 
		//}
	},
	actions: {
		//setMissingTranslation({ commit }, locale, key) {
		//	commit('setMissingTranslation', locale, key)
		//},
		isLoaded({ commit }) {
			commit('setIsLoaded')
		},
		fetch({ commit }) {
            return ApiService.view('/get-languages')
				.then(roles => {
					commit('setLanguages', roles)
					return Promise.resolve(roles)
				})
		},
    }
}
